import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../../../providers";
import { AdsStrings, AdsSubscriptionPageControllerImpl } from "../../../business";
import { AdsPlanDataResponse } from "../../interfaces";
import { AdsPageFactoryImpl } from "../factories";

export const AdsSubscriptionPage: React.FC = () => {
    const strings = AdsStrings['PTBR'].page;
    const { setCallbackLogin, handleLogout } = useAuth();
    const navigate = useNavigate();
    const [isLoading, setLoading] = useState<Boolean>(true);
    const [plansData, setPlansData] = useState<AdsPlanDataResponse>();

    const factory = new AdsPageFactoryImpl();
    const controller = new AdsSubscriptionPageControllerImpl();

    const fetchData = async () => {
        try {
            const response = await controller.onLoad();
            setLoading(false);
            setPlansData(response);
        } catch (error) {
            console.error("Erro na requisição:", error);
            if (error === "401") {
                setCallbackLogin(
                    {
                        goBack: true,
                        origin: '/ads/subscribe',
                    }
                );
                handleLogout();
                navigate('/auth');
            } else {
                setLoading(false);
            }
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <>
            <div className={"font-poppins mt-5"}>
                <h1 style={{ fontSize: 60, fontWeight: "bold" }}>{strings.title}</h1>
                {isLoading ? <Spinner animation="border" variant="primary" /> : factory.create(plansData)}
            </div>
            <div className={"mb-5 pb-5"}>
                <p
                    className={"text-center"}
                    dangerouslySetInnerHTML={{ __html: strings.description }}
                />
            </div>
        </>
    );
}
